import React, { useState, useMemo, useRef } from 'react'
import Box from '@mui/material/Box'
import { Document, Page, pdfjs } from 'react-pdf'
import 'react-pdf/dist/esm/Page/TextLayer.css'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import Loading from '../common/Loading'

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`

const PDFReader = ({ url, pageNumber, scale, onLoadSuccess }) => {
  const [isFirstLoad, setIsFirstLoad] = useState(true)
  const hasLoadedOnce = useRef(false)

  const file = useMemo(() => {
    if (!url) return null
    if (url instanceof Blob) return { data: url }
    return url
  }, [url])

  function handleDocumentLoadSuccess(doc) {
    if (!hasLoadedOnce.current) {
      setIsFirstLoad(false)
      hasLoadedOnce.current = true
    }
    if (onLoadSuccess) onLoadSuccess(doc)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        height: '100%',
        overflowY: 'auto'
      }}
    >
      <Document
        loading={isFirstLoad ? <Loading /> : null}
        file={file}
        onLoadSuccess={handleDocumentLoadSuccess}
        onLoadError={(error) => {
          setIsFirstLoad(false)
        }}
      >
        <Page pageNumber={pageNumber} scale={scale} />
      </Document>
    </Box>
  )
}

export default React.memo(PDFReader)
